
import { useState } from "react";
import {  Grid, MenuItem, TextField } from "@mui/material";
import { roles_permitidos } from "../../../data";
import { BotonesAndCargando } from "../../components/botones";
import { startSavingUsuario } from "../../../services";
import { LayoutCrearDoc } from "../../layouts";

import Swal from "sweetalert2";



const initUser = {
    nombre: "",
    cedula: "",
    ciudad: "",
    direccion: "",
    movil: "",
    establecimiento: "",
    profesion: "",
    role: "",
    email: "",
};



export const CrearUsuarios = () => {


    const [cargando, setCargando] = useState(false);
    const [formUsuario, setFormUsuario ] = useState( initUser );
    const { nombre, cedula, ciudad, direccion, movil, role, establecimiento, profesion, email } = formUsuario;


    const handleInputChange = ({ target }) => {
        setFormUsuario({
            ...formUsuario,
            [target.name]: target.value
        });
    }


    const handleCrearUsuario = async(e) => {
        e.preventDefault();
        if([nombre, email, role, direccion, movil].includes('') ) {
            return Swal.fire('Error', 'El Hay Datos Obligatorios', 'error');
        }
        setCargando(true);
        const resp = await startSavingUsuario(formUsuario);
        setCargando(false);
        if( resp ){ setFormUsuario( initUser ); }
    }




    return (

        <LayoutCrearDoc titulo={'Crear Usuario'} add={false}>
            <form className="formulario-total" onSubmit={ handleCrearUsuario } >
            <Grid container spacing={3} sx={{mt:1}}>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Nombre Usuario'
                        type='text'
                        placeholder='Nombre Usuario'
                        fullWidth
                        name="nombre"
                        value={ nombre }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Cedula Usuario'
                        type='text'
                        placeholder='Cedula Usuario'
                        fullWidth
                        name="cedula"
                        value={ cedula }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Correo Electronico'
                        type='text'
                        placeholder='Correo Electronico'
                        fullWidth
                        name="email"
                        value={ email }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Movil'
                        type='number'
                        placeholder='Movil'
                        fullWidth
                        name="movil"
                        value={ movil }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField 
                        variant="outlined"
                        label='Establecimiento'
                        type='text'
                        placeholder='Establecimiento'
                        fullWidth
                        name="establecimiento"
                        value={ establecimiento }
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField 
                        variant="outlined"
                        label='Profesión'
                        type='text'
                        placeholder='Profesión'
                        fullWidth
                        name="profesion"
                        value={ profesion }
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField 
                        variant="outlined"
                        label='Ciudad'
                        type='text'
                        placeholder='Ciudad'
                        fullWidth
                        name="ciudad"
                        value={ ciudad }
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Dirección'
                        type='text'
                        placeholder='Dirección'
                        fullWidth
                        name="direccion"
                        value={ direccion }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField 
                        required
                        variant="outlined"
                        select
                        label="Seleccione Rol"
                        fullWidth
                        name='role'
                        value={ role }
                        onChange={ handleInputChange }
                    >
                        <MenuItem value="">Seleccione Un Rol</MenuItem>
                        {roles_permitidos.map( item => (
                            <MenuItem key={item} value={item}>{ item }</MenuItem>
                        ))}
                    </TextField>
                </Grid>
            </Grid>


            <Grid container sx={{mb:3, mt:4, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo='Crear Usuario'
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        esSubmit
                    />
                </Grid>
            </Grid>

            </form>
        </LayoutCrearDoc>
    )
}
